import React from 'react';

import Combo from '../../commons/Combo';
import Filtros from '../../commons/Filtros';
import { useTablaFilter } from '../../commons/Formulario';

import { testeoModel } from '../../redux/models/testeo.model';
import { TYPE_FILTER } from '../../redux/helpers/app.types';

const TesteoFilter = () => {
  const { getData, params, dispatch, setSelectedItem } = useTablaFilter();
  return (
    <Filtros
      onFilter={() => getData()}
      onNew={() => setSelectedItem(testeoModel)}
    >
      <Combo
        name="st"
        label="Estado de registro"
        value={params.st}
        placeholder="Todos"
        tabIndex={202}
        size={3}
        data={[
          { value: '1', label: 'Vigente' },
          { value: '0', label: 'No Vigente' },
        ]}
        onChange={({ value }) => {
          dispatch({ type: TYPE_FILTER, payload: { st: value } });
        }}
      />
    </Filtros>
  );
};

export default TesteoFilter;
